<template>
  <div class="login_page">
    <div>
      <img src="../../static/logo1.jpg" />
    </div>
    <div class="name"> 
      
      <span class="ch_name">习传考试系统</span>
      <span class="en_name">Xi Chuan Examination System</span>
    </div>
    <el-form class="login_form" ref="form" :model="form" label-width="80px">
      <el-form-item label="">
        <el-input v-model="form.username" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="form.password" type="password" placeholder="密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="medium" style="width: 100%;" type="primary" :loading="load" @click="onSubmit">{{ login_text }}</el-button>
      </el-form-item>
    </el-form>
    
    <span class="Copyright">Copyright 2007 版权所有：四川习传文化传播有限公司</span>
  </div>
</template>
<script>
import Http from "../apis/user";
export default {
  name: 'Login',
  data(){
    return{
      form:{
        username:'',
        password:''
      },
      pollingTimer:null,
      load:false,
      login_text:'登录'
    }
  },
  beforeDestroy() {
    if (this.pollingTimer) {
      clearTimeout(this.pollingTimer);
    }
  },
  methods: {
  async onSubmit() {
    this.login_text = '登录中...'
    this.load = true
    try {
      const res = await Http.Login(this.form);

      this.$message({
        showClose: true,
        message: res.msg,
        type: res.code ? 'success' : 'error',
      });
      if (res.code) {
        this.login_text = '登录'
        this.load = false
        localStorage.setItem('token', res.data.userinfo.token);
        localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo));
        if (res.data.userinfo.type == 1) {
          this.$router.push({ name: 'Examlist' });
        } else {
          this.$router.push({ name: 'Studentexamlist' });
        }
      }else{
        this.login_text = '登录'
        this.load = false
      }

      //this.startPolling(res.data.job_id);
    } catch (error) {
      this.$message({
        showClose: true,
        message: '登录请求失败，请重试',
        type: 'error',
      });
    }
  },

  async startPolling(jobId, retryCount = 0) {
    const maxRetries = 5; // 最大重试次数
    const maxInterval = 8000; // 最大间隔 8 秒

    try {
      const res = await Http.getinfo({ jobid: jobId });

      if (res.code === -1 && retryCount < maxRetries) {
        // 任务未完成，继续轮询
        const interval = Math.min(1000 * Math.pow(2, retryCount), maxInterval);
        this.pollingTimer = setTimeout(() => {
          this.startPolling(jobId, retryCount + 1);
        }, interval);
        return;
      }

      // 处理登录结果
      this.$message({
        showClose: true,
        message: res.msg,
        type: res.code ? 'success' : 'error',
      });

      if (res.code) {
        this.login_text = '登录'
        this.load = false
        localStorage.setItem('token', res.data.userinfo.token);
        localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo));
        if (res.data.userinfo.type == 1) {
          this.$router.push({ name: 'Examlist' });
        } else {
          this.$router.push({ name: 'Studentexamlist' });
        }
      }
    } catch (error) {
      this.$message({
        showClose: true,
        message: '获取登录结果失败，请重试',
        type: 'error',
      });
    }
  },
}

}
</script>
<style lang="less" scoped>
.login_page {
  width: 1200px;
  margin: 100px auto;

  img {
    width: 169px;
    height: 100px;
  }

  .name {
    width: 100%;
    display: inline-block;
    text-align: center;
    margin-top: 30px;
  }

  .ch_name {
    width: 100%;
    display: inline-block;
    font-size: 30px;
    font-weight: 700;
  }

  .en_name {
    width: 100%;
    display: inline-block;
    font-size: 22px;
    font-weight: 700;
    opacity: 0.7;
  }

  .login_form {
    width: 340px;
    margin: 100px auto;
  }

  .Copyright {
    font-size: 14px;
    display: inline-block;
    width: 100%;
    text-align: center;
  }

  // 媒体查询，针对手机端样式调整
  @media (max-width: 767px) {
    width: 100%;
    margin: 30px auto;

    img {
      width: 120px;
      height: auto;
      display: block;
      margin: 0 auto;
    }

    .name {
      margin-top: 20px;
    }

    .ch_name {
      font-size: 24px;
    }

    .en_name {
      font-size: 18px;
    }

    .login_form {
      width: 90%;
      margin: 30px auto;
    }
  }
}

.login_form::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>